import MessageSeparator from './MessageSeparator';

export default MessageSeparator;
